"use client";
import { useTheme } from "@quales/utils/theme";
import axios from "axios";
import React from "react";
import { RegistrationForm, RegistrationFormState } from "../../forms";
import {
  Box,
  WcButton,
  WcCheckBox,
  WcFormControlLabel,
  WcLink,
  WcPaper,
  WcStack,
  WcTypography,
} from "@bpipartners/webui";
import { enqueueSnackbar } from "notistack";
import { useTranslations } from "next-intl";
import { useMediaQuery } from "@mui/material";

export const RegistrationComposite = () => {
  const registerRef = React.useRef();
  const theme = useTheme();
  const isExtraSmallSize = useMediaQuery(theme.breakpoints.down("md"));
  const t = useTranslations();

  const minWidth = 1100;
  const minWidthForm = 650;

  const [tcConfirm, setTCconfrim] = React.useState(false);
  const handleRegisterClicked = () => {
    if (registerRef && registerRef.current) {
      //@ts-ignore
      registerRef.current.onSubmit();
    }
  };

  const handleRegistrationDetails = (val: RegistrationFormState) => {
    if (val) {
      axios
        .post(
          "/register/newAccount",
          {
            organization: val.organization,
            emailAddressInvoice: val.emailAddressInvoice,
            Street: val.street,
            number: val.number,
            postalCode: val.postalCode,
            city: val.city,
            phoneNumber: val.phoneNumber,
            firstName: val.firstName,
            infix: val.infix,
            lastName: val.lastName,
            purchaseNumber: val.purchaseNumber,
            reference: val.reference,
            emailAddress: val.emailAddress,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            withCredentials: true,
          }
        )
        .then((res: any) => {
          if (res && res.status === 200) {
            enqueueSnackbar(t("feedback.registrationSuccess"), {
              variant: "success",
            });

            setTimeout(() => {
              window.location.replace("https://quales.nl");
            }, 3000);
          }
        })
        .catch((FEerror: any) => {
          enqueueSnackbar(t("feedback.registrationError"), {
            variant: "success",
          });
        });
    }
  };

  const handleTC = (event: React.ChangeEvent<HTMLInputElement>) => {
    setTCconfrim(event.target.checked);
  };

  return (
    <WcStack
      id="registration-container"
      width={"100%"}
      height={"100%"}
      maxWidth={1400}
      position="relative"
      sx={{
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          height: "100%",
          background: `
          linear-gradient(to right, ${theme.appColors.primary}, ${theme.appColors.inversePrimary})
          `,
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%, 100% 100%",
          backgroundPosition: "top, bottom",
          zIndex: -1,
        },
      }}
    >
      <WcStack
        id={"header"}
        spacing={4}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
        bgcolor={theme.appColors.inversePrimary}
        // to stay sticky
        position="sticky"
        top={0}
        zIndex={1000}
        height={"120px"}
        paddingX={20}
        paddingY={8}
      >
        <Box
          component="img"
          sx={{
            maxHeight: 80,
            ":hover": {
              cursor: "pointer",
            },
            // width: 180,
          }}
          //@ts-ignore
          alt="Quales logo"
          src={
            "https://storage.googleapis.com/qualesstatic/quales-logo-white-without-slogan.png"
          }
          onClick={() => window.location.replace("https://quales.nl")}
        />
        {!isExtraSmallSize && (
          <WcTypography variant="h5" color={theme.appColors.onPrimary}>
            Voor{" "}
            <span style={{ color: theme.appColors.secondary }}>
              €325,- per jaar
            </span>{" "}
            kunnen al uw medewerkers gebruik maken van Quales en de Quales app
          </WcTypography>
        )}
      </WcStack>
      <WcStack
        id="RegistrationComposite"
        minHeight={700}
        alignItems={"center"}
        alignSelf={"center"}
        direction={"row"}
        paddingTop={"30px"}
        paddingBottom={"20px"}
      >
        <WcStack p={2} pb={2}>
          <WcPaper sx={{ p: 4 }}>
            <RegistrationForm
              ref={registerRef}
              onRegistrationDetails={handleRegistrationDetails}
            />

            <WcStack spacing={2} padding={3}>
              <WcFormControlLabel
                control={
                  <WcCheckBox
                    sx={{ width: 30 }}
                    defaultChecked={false}
                    onChange={handleTC}
                    value={tcConfirm}
                  />
                }
                label={
                  <WcStack direction={"row"} width={"100%"}>
                    <WcTypography variant="caption">
                      Ik ga akkoord met de
                      <WcLink
                        sx={{
                          textDecoration: "none",
                          fontWeight: "700",
                          color: theme.appColors.secondary,
                        }}
                        mx={1}
                        onClick={(e) => {
                          e.preventDefault();
                          window.open(
                            "https://quales.nl/terms_conditions/",
                            "_blank"
                          );
                        }}
                      >
                        algemene voorwaarden
                      </WcLink>
                      en plaats een bestelling met een betalingsverplichting
                    </WcTypography>
                  </WcStack>
                }
              />
            </WcStack>

            <WcStack p={2} alignItems={"flex-end"}>
              <WcButton
                variant="contained"
                // disabled={!tcConfirm}
                onClick={handleRegisterClicked}
                sx={{
                  width: 180,
                  backgroundColor: theme.appColors.tertiary,
                  ":hover": {
                    backgroundColor: theme.appPalette.tertiary[60],
                  },
                }}
              >
                Bestellen
              </WcButton>
            </WcStack>
          </WcPaper>
        </WcStack>
        {!isExtraSmallSize && (
          <WcStack width={"50%"} spacing={20} alignSelf={"start"}>
            <Box
              component="img"
              sx={{
                width: 350,
                paddingTop: 4,
              }}
              //@ts-ignore
              alt="Quales logo"
              src={
                "https://storage.googleapis.com/qualesstatic/qualestablet.png"
              }
            />
            <Box
              component="img"
              sx={{
                width: 400,
                paddingTop: 4,
              }}
              //@ts-ignore
              alt="Quales logo"
              src={
                "https://storage.googleapis.com/qualesstatic/qualesBannerApp.png"
              }
            />
          </WcStack>
        )}
      </WcStack>
    </WcStack>
  );
};

export default RegistrationComposite;
